export const isRanEligible = ({ preview, portalConfiguration, user}) => {
  if (preview.isEnabled()) return true;
  if (portalConfiguration.has_offers && portalConfiguration.has_offers.ran) return true;

  return isElligibleToFreeRan({ portalConfiguration, user })
}

export const isElligibleToFreeRan = ({ portalConfiguration, user }) => {
  return portalConfiguration.free_ran_enabled && user.data && user.data.free_ran_elligible;
}

export const hasOffers = ({ portalConfiguration }) => {
  const offers = portalConfiguration.has_offers

  if (!offers) return false

  const activeOffers = Object.keys(offers).filter((key) => offers[key])

  return activeOffers && activeOffers.length > 0
}

export const hasRan = ({ getRooms }) => {
  return getRooms().length > 0
}
